import { render, staticRenderFns } from "./CompanySummaryAside.vue?vue&type=template&id=40720008"
import script from "./CompanySummaryAside.vue?vue&type=script&lang=js"
export * from "./CompanySummaryAside.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports